"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/TwitterFill.tsx
function TwitterFill(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M21.594 5.244c.19-.41-.271-.749-.673-.539a8.41 8.41 0 01-1.74.682c-1.454-1.69-4.09-1.868-5.727-.356-1 .8-1.454 1.867-1.454 3.023v.89a9.773 9.773 0 01-7.648-3.34c-.252-.287-.711-.23-.826.133-.668 2.112-1.775 7.89 4.838 10.765a10.903 10.903 0 01-4.23 1.65c-.522.085-.68.83-.183 1.013 7.724 2.84 16.14-1.617 16.14-11.041v-.781a7.24 7.24 0 001.503-2.099z"
  }));
}
var TwitterFill_default = TwitterFill;

exports.TwitterFill_default = TwitterFill_default;
